/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import {
  Col,
  Row,
  Select,
  Input,
  Button,
  Modal,
  Table,
  Checkbox,
  DatePicker,
} from "antd";
import TitlePage from "../../component/Desktop/titlePage";
import InputPositiveNumber from "../../component/Desktop/inputPositiveNumber";
import GroupItem from "../../component/Desktop/groupItem";
import RowInput from "../../component/Desktop/rowInput";
import SearchMachine from "../../component/Desktop/searchMachine";
import Loading from "../../component/Desktop/loading/loading";
import {
  COMMON_CONSTANT,
  KEY,
  STYLE,
  lang,
} from "../../constants/common.const";
import API from "../../api/backend/workReport";
import API_INVENTORY from "../../api/backend/inventory";
import KBN from "../../api/backend/kbn";
import {
  renderOption,
  MSG_CATCH,
  statusRes,
  getNameFile,
  getDotFile,
  isImage,
  hasPreview,
  showMessage,
  removeItemArr,
  isEmpty,
  renderOptionOneCheck,
  handleCatchError,
} from "../../constants/utils";
import { Link, useHistory, useLocation } from "react-router-dom";
import ListHistoryCL from "../../page/History_CL/listPopup";
import AutoMail from "../../component/Desktop/autoMail";
import { useParams } from "react-router-dom";

import {
  CloseCircleOutlined,
  CloseCircleFilled,
  SaveOutlined,
  PaperClipOutlined,
  DeleteOutlined,
  PlusOutlined,
  SearchOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import classDdl from "../../models/control/dropdownlist";
import classCheckbox from "../../models/control/checkbox";
import classBuhin from "../../models/machineBuhin";
import classText from "../../models/control/text";
import classMachine from "../../models/machineDes";
import classPopup from "../../models/control/popup";
import moment from "moment";
import { useSelector } from "react-redux";
import { checkRoleScreen } from "../../utils/roles";
import ReportMachineForm, { reportDataOrigin } from "./reportMachine";
import SearchEquipmentNew from "../../component/Desktop/searchEquipmentNew";
import { workReportNewEquipmentApi } from "../../api/backend/reportNewEquipment";
import kbn from "../../api/backend/kbn";
import SearchEquipmentNew2 from "../../component/Desktop/searchEquipmentNew2";
import { VideoApi } from "../../api/backend/video";
import { TagVideoSelect } from "../../component/video/TagVideoSelect";

//Declare global variables
const { TextArea } = Input;
let FLAG_CHANGE_DATA = false;
const formDataAttach = new FormData();
let indexFile = 0;

function EditReportNew() {
  let { id, id: modeUpdate, typeReport, idResultCheck } = useParams();
  const history = useHistory();
  let [initPage, setInitPage] = useState(true);
  let [showLoading, setShowLoading] = useState(false);
  const { allowRoute } = useSelector((state) => state.auth);
  const { isYuni } = useSelector((state) => state.auth);
  const [tags,setTags] = useState([])
  const [listAllTag,setListAllTag] = useState([])

  const location = useLocation();
  // Loading
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };

  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };

  // Group 1
  let [hdnChecklistID, sethdnChecklistID] = useState(new classText());
  let [txtName, settxtName] = useState(new classText()); //Required
  let [reportDate, setReportDate] = useState(new classText());
  let txtNameEl = useRef(null);
  let reportDateRef = useRef(null);
  let [ddlReportType, setddlReportType] = useState(new classDdl()); //Required
  let [ddlPriority, setddlPriority] = useState(new classDdl());
  let [txtStatus, settxtStatus] = useState(new classText());
  let [peConfirm, setpeConfirm] = useState(new classText());
  let [peApprove, setpeApprove] = useState(new classText()); //Required
  let [peApproveEl, setpeApproveEl] = useState(null);
  const [buhins, setBuhins] = useState([]);
  const managerRef =  useRef()

  // REPORT MACHINE
  const searchParams = new URLSearchParams(window.location.search);
  const idMachine = searchParams.get("idMachine");
  const paddingCol = ddlReportType.value == "3" ? "0" : "";

  const [listEquipment, setListEquipment] = useState([]);
  const rowInputStyle =
    ddlReportType.value == "3"
      ? {
          labelCol: 4,
          labelLeft: true,
        }
      : {};
  const [listImage, setListImage] = useState([]);

  const isReportNewEquipment = Number(ddlReportType.value) === 3;
  const fromToChartItem = idMachine && !modeUpdate;
  const [reportData, setReportData] = useState(JSON.parse(JSON.stringify(reportDataOrigin)));
  const [listAttachMachine, setListAttachMachine] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const [optionNewEquipment, setOptionNewEquipment] = useState({
    WORK_REPORT_OR_INQUIRY: [],
    REPORT_TYPE: [],
    OCCURRENCE_STATUS: [],
    SIMPLE_REPAIR_STATUS: [],
    NOT_COMPLETED_PROPOSED: [],
    CONTRACTOR_MEASURES_ACTION: [],
    PRIORITY_NEW: [],
    CLIENT_RESPONSE: [],
    DISCUSSION_RESULT: [],
    YES_NO: [],
  });

  // Focus
  const fileEl = useRef(null);
  const fileElManagement = useRef(null);

  // Table
  let [dataMachine, setdataMachine] = useState([]);
  let [rowShow, setrowShow] = useState([]);

  //
  let [txtTroubleInformation, settxtTroubleInformation] = useState(
    new classText()
  ); //Required
  let txtTroubleInformationEl = useRef(null);
  let [txtRenovationMethod, settxtRenovationMethod] = useState(new classText()); //Required
  let txtRenovationMethodEl = useRef(null);
  const [chkAutoExport, setChkAutoExport] = useState({
    ...new classCheckbox(),
    checked: true,
  });

  // Popup
  let [popupHistoryCL, setPopupHistoryCL] = useState(new classPopup());
  let [popupAttach, setPopupAttach] = useState(new classPopup());
  const [idSelect, setIdSelect] = useState(null);
  const [dataSelected, setDataSelected] = useState(null);

  const [haveAdded,setHaveAdded] = useState(false)
  
  // In-Popup
  let [tblAttach, setTblAttach] = useState([]);

  // Show hide expand
  const showHideRow = (v, row) => {
    if (v) {
      rowShow.push(row.ID);
    } else {
      rowShow = removeItemArr(rowShow, row.ID);
    }
    setrowShow([...rowShow]);
  };
  const enableUpdateMachine = !(modeUpdate && chkAutoExport.checked);

  // Column Machine
  const colFix = [
    { title: "機器名", dataIndex: "Name", width: "20%" },
    { title: "施設", dataIndex: "facilityName", align: "center", width: "16%" },
    { title: "棟", dataIndex: "buildingName", align: "center", width: "14%" },
    { title: "階", dataIndex: "floorName", align: "center", width: "10%" },
    { title: "部屋", dataIndex: "roomName", align: "center", width: "12%" },
    {
      title: "プロセス",
      dataIndex: "processName",
      align: "center",
      width: "9%",
    },
  ];
  const colSelect = {
    title: "交換", // Select
    width: "9%",
    align: "center",
    dataIndex: "checked",
    render: (txt, row = classMachine(), id) => {
      return (
        <Checkbox
          checked={txt}
          onChange={(v) => {
            let checked = v.target.checked;
            showHideRow(checked, row);
            dataMachine[id].checked = checked;
            setdataMachine(dataMachine);
          }}
        ></Checkbox>
      );
    },
  };
  const colDel = {
    title: "削除", // Del
    width: "9%",
    align: "center",
    render: (txt, row, index) => {
      return (
        <Button
          type="link"
          onClick={() => {
            let lNew = [...dataMachine];
            lNew = lNew.filter((v) => v.ID !== row.ID);
            setdataMachine(lNew);
          }}
        >
          <CloseCircleFilled className="iconM red" />
        </Button>
      );
    },
  };
  const columnsMachineSelect = enableUpdateMachine
    ? [...colFix, colSelect, colDel]
    : [...colFix];

 

  // Change data
  useEffect(() => {
    if (!initPage) {
      FLAG_CHANGE_DATA = true;
    }
  }, [
    hdnChecklistID,
    txtName,
    txtNameEl,
    ddlReportType,
    ddlPriority,
    txtStatus,
    peConfirm,
    peApprove,
    dataMachine,
    txtTroubleInformation,
    txtRenovationMethod,
  ]);

  function formatTimestampToDate(timestamp) {
    if (!timestamp) return null;
    return moment.unix(Number(timestamp));
  }
  const setDetailEquipment = (dataDetail, ops,opsAllUser,opsHeadUser) => {
    const reportDataNew = { ...reportData };
    reportDataNew.clientName.value = dataDetail.clientName;
    reportDataNew.contractorName.value = dataDetail.contractorName;
    reportDataNew.reportOrInquiry.value = dataDetail.reportOrInquiry;
    reportDataNew.reportCategory.value = dataDetail.reportCategory;
    reportDataNew.equipmentId.value = dataDetail.equipmentId;
    reportDataNew.reportManagementNumber.value =
      dataDetail.reportManagementNumber;
    reportDataNew.createDate.value = formatTimestampToDate(
      dataDetail.reportDate
    );
    reportDataNew.resubmitDate.value = formatTimestampToDate(
      dataDetail.resubmissionDate
    );
    reportDataNew.subject.value = dataDetail.subject;
    reportDataNew.facility.value = dataDetail.facilityName;
    reportDataNew.location.value = dataDetail.installLocation;
    reportDataNew.machineForSiteOfficeCode.value =
      dataDetail.machineForSiteOfficeCode;
    reportDataNew.equipmentName.value = dataDetail.machineForSiteOfficeName;
    reportDataNew.modelSpec.value = dataDetail.modelNumber;
    reportDataNew.reporter.value = dataDetail.reporter;
    reportDataNew.manager.value =  opsHeadUser.find(i => i.key == dataDetail.manager)  ? dataDetail.manager :  "";
    reportDataNew.assistantManager.value = opsAllUser.find(i => i.key == dataDetail.assistantManager) ? dataDetail.assistantManager : "";
    reportDataNew.occurrenceDateTime.value = formatTimestampToDate(
      dataDetail.occurrenceDateTime
    );
    reportDataNew.occurrenceStatus.value = dataDetail.occurrenceStatus;
    reportDataNew.situationDescription.value = dataDetail.situationDescription;
    reportDataNew.simpleRepairStatus.value = dataDetail.simpleRepairStatus;
    reportDataNew.notCompletedProposed.value = dataDetail.notCompletedProposed;
    reportDataNew.contractorMeasuresAction.value =
      dataDetail.contractorMeasuresAction;
    reportDataNew.priority.value = dataDetail.priority;
    reportDataNew.importance.value = dataDetail.important;
    reportDataNew.attachedDocument.value = dataDetail.attachedDocument;
    reportDataNew.quotation.value = dataDetail.quotation;
    reportDataNew.clientResponseDate.value = formatTimestampToDate(
      dataDetail.clientResponseDate
    );
    reportDataNew.clientResponse.value = dataDetail.clientResponse;
    reportDataNew.clientSeal.value = dataDetail.clientSeal;
    reportDataNew.discussionResult.value = dataDetail.discussionResult;
    reportData.additionalApprover.value =opsAllUser.find(i => i.key == dataDetail.additionalApprover) ? dataDetail.additionalApprover : ""

    setReportData(reportDataNew);
    setListImage(dataDetail.listWorkReportImage);
    setListAttachMachine(dataDetail.listWorkReportAttachment);

    settxtName({ ...txtName, value: dataDetail.name });
    setddlReportType({
      ...ddlReportType,
      value: dataDetail.reportType,
      options: ops,
    });
    settxtRenovationMethod({
      ...txtRenovationMethod,
      value: dataDetail.solution,
    });
    settxtTroubleInformation({
      ...txtTroubleInformation,
      value: dataDetail.description,
    });
    settxtStatus({
      ...txtStatus,
      value: dataDetail.statusValue,
      valueKey: dataDetail.status,
    });
  setHaveAdded(dataDetail.additionalApprover ? true : false)
  setTags(dataDetail.tagLists || [])

  };

  // Init
  useEffect(() => {
    if (checkRoleScreen(location.pathname, allowRoute)) {
      openLoadingSpinner();
      setInitPage(true);

      // Detail
      Promise.all([
        id ? workReportNewEquipmentApi.getDetail(id) : null,
        KBN.getPriority(),
        KBN.getWorkReportType(),
        idResultCheck ? API.getCheckResult(idResultCheck) : null,
        API_INVENTORY.searchItems({
          inventoryType: 2,
        }),
        VideoApi.getListTag(),
        workReportNewEquipmentApi.searchUser({
          type:"user"
        }),
        workReportNewEquipmentApi.searchUser({
          type:"officeAdmin"
        })
      ])
        .then((res) => {
          if (res[0] && !res[0].data && id) {
            history.push("/WorkReportManagement");
            return;
          }
          let d1 = res[0] ? res[0].data : {};
          let d2 = res[1] ? res[1].data.data : []; // ddlPriority
          let d3 = res[2] ? res[2].data.data : []; // ddlReportType
          let d4 = res[3] ? res[3].data : {}; // result check name
          let d5 = res[4] ? res[4].data : {}; // listBuhin
          let d6 = res[5] ? res[5].data :[]; // TAG
          let d7 = res[6] ? res[6].data :[];
          let d8 = res[7] ? res[7].data :[];

          const opsAllUser = d7.map((item) => ({
            value: `${item.displayName}`,
            key: item.userName,
              }));
          const opsHeadUser = d8.map((item) => ({
            value: `${item.displayName}`,
            key: item.userName,
              }));
          
          // TAG
          setListAllTag(d6)
          // Buhin
          setBuhins(
            d5.data.map((item) => {
              item["key"] = item.inventoryItemCode;
              item["name"] = item.inventoryItemName;
              return item;
            })
          );
          //   let reportDate = d1.reportDate
          //     ? moment.unix(d1.reportDate)
          //     : moment(new Date());
          //   setReportDate({ ...reportDate, value: reportDate });
          // Data detail
          if (id) {
            setddlPriority({ ...ddlPriority, options: d2, value: d1.priority });
            // Detail - 0
            setDetailEquipment(d1, d3,opsAllUser,opsHeadUser);
          }
        })
        .catch((err) => {
          console.log(err)
          showMessage(KEY.ERROR, MSG_CATCH());
        })
        .then(() => {
          setTimeout(() => {
            setInitPage(false);
          }, 500); // waiting for setup
          closeLoadingSpinner();
        });
    }
  }, [allowRoute]);

  useEffect(() => {
    let trouble = { ...txtTroubleInformation },
      confrim = { ...peConfirm },
      approve = { ...peApprove },
      priority = { ...ddlPriority };

    if (Number(ddlReportType.value) === 1) {
      // 作業報告
      trouble.show = false;

      // Hide email confirm/approve
      confrim.show = false;
      approve.show = false;

      // //F11B11SHIEV-2725
      // // Disable 優先度
      priority.value = "";
      priority.disabled = true;
    } else {
      /// トラブル報告
      trouble.show = true;

      // Show email confirm/approve
      confrim.show = true;
      approve.show = true;

      // //F11B11SHIEV-2725
      priority.disabled = false;
    }
    //check permission from other factory
    // TODO

    // Update state
    settxtTroubleInformation(trouble);
    setpeConfirm(confrim);
    setpeApprove(approve);
    setddlPriority(priority);
  }, [ddlReportType.value]);

  // GET KBN NEW
  const getKbnSelectNew = async () => {
    try {
      const listKey = [
        "WORK_REPORT_OR_INQUIRY",
        "REPORT_TYPE",
        "OCCURRENCE_STATUS",
        "SIMPLE_REPAIR_STATUS",
        "NOT_COMPLETED_PROPOSED",
        "CONTRACTOR_MEASURES_ACTION",
        "PRIORITY_NEW",
        "CLIENT_RESPONSE",
        "DISCUSSION_RESULT",
        "YES_NO",
      ];
      let listPromise = [];
      listKey.forEach((key) => {
        listPromise.push(() => kbn.getReportTypeByName({ name: key }));
      });
      const newOptions = { ...optionNewEquipment };
      const resArr = await Promise.all(listPromise.map((func) => func()));
      listKey.forEach((key, index) => {
        newOptions[key] = resArr[index].data.data;
      });

      setOptionNewEquipment({ ...newOptions, isFetch: true });
    } catch (error) {
      console.log(error);
      handleCatchError(error);
    }
  };

  useEffect(() => {
    if (isReportNewEquipment && !optionNewEquipment.isFetch) {
      getKbnSelectNew();
    }
  }, [isReportNewEquipment, optionNewEquipment.isFetch]);

  // Popup common
  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    let callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };

  const onCloseSearchHistory = () => {
    setPopupHistoryCL({ ...popupHistoryCL, show: false });
    setDataSelected(null);
    setIdSelect(null);
  };

  //Save function: 1
  function confirmSaveData() {
    if (isReportNewEquipment) {
      handleSaveNewReportEquipment();
      return;
    }

    return false;
  }

  function backToSearch() {
    history.goBack();
  }

  function cancelSaveData() {
    if (!FLAG_CHANGE_DATA && !idResultCheck) {
      // No update
      backToSearch();
    } else {
      // Updated
      FLAG_CHANGE_DATA = false;
      showConfirmMessage(
        COMMON_CONSTANT.BOM_C018,
        function () {
          backToSearch();
        },
        function () {
          FLAG_CHANGE_DATA = true;
        }
      );
    }
  }

  // Start: Tbl Attach
  function showAttachFileLst() {
    // Show popup
    setPopupAttach({ ...popupAttach, show: true });
  }

  const listWarehouseByItem = (itemCode) => {
    return (
      buhins
        // Get list warehouse by item
        .filter((i = new classBuhin()) => i.inventoryItemCode === itemCode)[0]
        // to Option
        .warehouseItems.map((wh) => {
          wh["key"] = wh.inventoryWarehouseItemCode;
          wh["name"] = wh.inventoryWarehouseName;
          return wh;
        })
    );
  };

  // Report new machine
  const addEquipmentToForm = (list = []) => {
    // Filter duplicate
    listEquipment.forEach((m = new classMachine()) => {
      list = list.filter(
        (l = new classMachine()) => String(m.ID) !== String(l.ID)
      );
    });

    //
    list.map((m = new classMachine()) => {
      m.checked = false;
      return m;
    });

    if (list && Array.isArray(list) && list.length > 0) {
      const firstMachine = list[0];
      const newReportData = { ...reportData };
      newReportData.facility.value = firstMachine.facilityName;
      newReportData.equipmentName.value = firstMachine.Name;
      newReportData.machineForSiteOfficeCode.value = firstMachine.code;
    }

    setListEquipment(list);
  };

  function validateSaveNewEquipment() {
    const manager = reportData.manager
    const assistantManager  = reportData.assistantManager;
    const additionalApprover = reportData.additionalApprover
    let flagErr = false,
      elmFocus;
    txtName = { ...txtName, value: txtName.value.trim(), error: false };
    peApprove = { ...peApprove, value: peApprove.value, error: false };
    txtTroubleInformation = {
      ...txtTroubleInformation,
      value: txtTroubleInformation.value.trim(),
      error: false,
    };
    txtRenovationMethod = {
      ...txtRenovationMethod,
      value: txtRenovationMethod.value.trim(),
      error: false,
    };

    if (String(txtRenovationMethod.value) === "") {
      flagErr = true;
      // Border red
      txtRenovationMethod = { ...txtRenovationMethod, error: true };
      elmFocus = txtRenovationMethodEl;
    }
    if (String(txtTroubleInformation.value) === "") {
      flagErr = true;
      // Border red
      txtTroubleInformation = { ...txtTroubleInformation, error: true };
      elmFocus = txtTroubleInformationEl;
    }
    if (txtName.value.length === 0) {
      flagErr = true;
      // Border red
      txtName = { ...txtName, error: true };
      elmFocus = txtNameEl;
    }
    if(String(manager.value) === ""){
      flagErr = true;
      manager.error = true
      if(managerRef.current){
        managerRef.current.focus()
      }
    }else{
      manager.error = false;
    }
    if(assistantManager.value && assistantManager.value === additionalApprover.value){
      flagErr = true;
      assistantManager.error = true
    }
    else{
      assistantManager.error = false
    }
    if(additionalApprover.value && assistantManager.value === additionalApprover.value){
      flagErr = true;
      additionalApprover.error = true
    }
    else{
      additionalApprover.error = false
    }
    if (Number(ddlReportType.value) === 2) {
      //トラブル報告

      if (peApprove.list.length === 0 || peApprove.message.length > 0) {
        flagErr = true;
        // Border red
        peApprove = { ...peApprove, error: true };
        elmFocus = peApproveEl;
      }
    }

    if (txtName.value.length === 0) {
      flagErr = true;
      // Border red
      txtName = { ...txtName, error: true };
      elmFocus = txtNameEl;
    }
    // Focus item error
    elmFocus && elmFocus.current && elmFocus.current.focus();

    // Update state
    settxtName(txtName);
    settxtTroubleInformation(txtTroubleInformation);
    settxtRenovationMethod(txtRenovationMethod);
    setReportData({
      ...reportData,
      manager,
      assistantManager,
      additionalApprover
    })
    return !flagErr;
  }

  // SAVE NEW REPRT
  async function handleSaveNewReportEquipment() {
    if (validateSaveNewEquipment()) {
      showConfirmMessage(COMMON_CONSTANT.BOM_C009, async function () {
        openLoadingSpinner();
        const body = {
          checkResultId: "",
          listMachineInfo: [
            {
            machineForSiteOfficeCode: reportData.machineForSiteOfficeCode.value,
            machineForSiteOfficeName:reportData.equipmentName.value,
            lstBuhin:[],
            }
          ],
          listAttachment: listAttachMachine.map((att, index) => ({
            ...att,
            itemOrder: index + 1,
          })),
          name: txtName.value,
          reportType: ddlReportType.value,
          priority: reportData.priority.value,
          // confirmer:null,
          // mailConfirm: null,
          // approver:  null,
          // mailApprove: null,
          description: txtTroubleInformation.value,
          solution: txtRenovationMethod.value,
          createId: reportData.createId,
          // createExport: false,
          reportDate: reportData.createDate.value
            ? moment(reportData.createDate.value).unix()
            : null,
          clientName: reportData.clientName.value,
          contractorName: reportData.contractorName.value,
          reportOrInquiry: reportData.reportOrInquiry.value,
          reportCategory: reportData.reportCategory.value,
          equipmentId: reportData.equipmentId.value,
          reportManagementNumber: reportData.reportManagementNumber.value,
          resubmissionDate: reportData.resubmitDate.value
            ? moment(reportData.resubmitDate.value).unix()
            : null,
          subject: reportData.subject.value,
          machineForSiteOfficeCode: reportData.machineForSiteOfficeCode.value,
          reporter: reportData.reporter.value,
          manager: reportData.manager.value,
          assistantManager: reportData.assistantManager.value,
          occurrenceDateTime: reportData.occurrenceDateTime.value
            ? moment(reportData.occurrenceDateTime.value).unix()
            : null,
          occurrenceStatus: reportData.occurrenceStatus.value,
          situationDescription: reportData.situationDescription.value,
          simpleRepairStatus: reportData.simpleRepairStatus.value,
          notCompletedProposed: reportData.notCompletedProposed.value,
          contractorMeasuresAction: reportData.contractorMeasuresAction.value,
          important: reportData.importance.value,
          attachedDocument: reportData.attachedDocument
            ? reportData.attachedDocument.value
            : "",
          quotation: reportData.quotation.value,
          clientResponseDate: reportData.clientResponseDate.value
            ? moment(reportData.clientResponseDate.value).unix()
            : null,
          clientResponse: reportData.clientResponse.value,
          clientSeal: reportData.clientSeal.value,
          discussionResult: reportData.discussionResult.value,
          listImage: listImage.map((image, index) => ({
            ...image,
            itemOrder: index + 1,
          })),
          additionalApprover: reportData.additionalApprover.value,
          tagLists:tags
        };
        try {
          await workReportNewEquipmentApi.updateReport(id, body);
          showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, backToSearch);
        } catch (error) {
          handleCatchError(error);
        } finally {
          closeLoadingSpinner();
        }
      });
    }
  }
  return (
    <div className="des-content">
      <Loading show={showLoading}></Loading>
      <TitlePage name={id ? "作業報告編集" : "作業報告作成"} />
      {/* Group 1 */}
      <GroupItem name="報告情報" sub="報告の情報をご入力ください。" center>
        {!isReportNewEquipment && (
          <RowInput name={lang.CHECK_RESULT_DESTINATION}>
            <Row justify="space-between" gutter={[16, 8]}>
              <Col span="24" className="textOverflow ">
                <Button
                  className="buttonPC button--info wAuto"
                  onClick={() => {
                    setPopupHistoryCL({ ...popupHistoryCL, show: true });
                  }}
                >
                  <SearchOutlined className="" />
                  {lang.SEARCH}
                </Button>
                <Link
                  className="ml15"
                  target="_blank"
                  to={"/history-detail/" + hdnChecklistID.value}
                >
                  {hdnChecklistID.message}
                </Link>
              </Col>
            </Row>
          </RowInput>
        )}

        <RowInput name={lang.REPORT_NAME} required>
          <Input
            ref={txtNameEl}
            maxLength={255}
            className={txtName.error ? STYLE.BORDER_RED : ""}
            value={txtName.value}
            onChange={(e) => settxtName({ ...txtName, value: e.target.value })}
          />
        </RowInput>

        {!isReportNewEquipment && (
          <RowInput name={lang.REPORT_DATE} required>
            <DatePicker
              format={reportDate.format || KEY.DATE_DEFAULT}
              ref={reportDateRef}
              value={reportDate.value}
              picker={reportDate.picker}
              placeholder={reportDate.format || KEY.DATE_DEFAULT}
              disabledDate={(d) => !d || d.isAfter(new Date())}
              className={"w100 " + (reportDate.error ? STYLE.BORDER_RED : "")}
              onChange={(v, dateString) => {
                setReportDate({
                  ...reportDate,
                  value: v,
                });
              }}
              {...reportDate.input}
            />
          </RowInput>
        )}

        <RowInput name={lang.REPORT_LEVEL} required>
          <Row>
            <Col span="10">
              <Select
                disabled={modeUpdate}
                value={ddlReportType.value}
                className="w100"
                onChange={(v) => {
                  setddlReportType({ ...ddlReportType, value: v });
                }}
              >
                {renderOption(ddlReportType.options, false)}
              </Select>
            </Col>
          </Row>
        </RowInput>

        {id && (
          <>
            <RowInput name={lang.STATUS} required>
              <Input value={txtStatus.value} disabled />
            </RowInput>
          </>
        )}
        <RowInput name={"参照動画"} >
              <TagVideoSelect tags={tags} listAll={listAllTag} setTags={setTags} className={"w100"} /> 
          </RowInput>

      </GroupItem>
      {isReportNewEquipment && (
        <GroupItem
          name="機器選択"
          sub="機器の部品等を交換する場合、以下の情報をご入力ください。"
          expand
          center
          initExpand={false}
        >
          {isYuni ? (
            <SearchEquipmentNew
              listMachineAdded={listEquipment}
              onAdd={addEquipmentToForm}
              getBuhin={false}
              maxChecked={1}
            />
          ) : (
            <SearchEquipmentNew2
              listMachineAdded={listEquipment}
              onAdd={addEquipmentToForm}
              getBuhin={false}
              maxChecked={1}
            />
          )}
        </GroupItem>
      )}

      {/* Report Machine Form */}
      {Number(ddlReportType.value) === 3 && (
        <GroupItem
          paddingCol={"0"}
          name="不具合報告"
          expand
          center
          initExpand={true}
        >
          <ReportMachineForm
            reportData={reportData}
            setReportData={setReportData}
            listAttachMachine={listAttachMachine}
            setListAttachMachine={setListAttachMachine}
            imageUrl={imageUrl}
            setImage={setImageUrl}
            optionNewEquipment={optionNewEquipment}
            listImage={listImage}
            setListImage={setListImage}
            showApprove={haveAdded}
            managerRef={managerRef}
          />
        </GroupItem>
      )}
      {/* Comment */}
      {/* Comment */}
      <GroupItem center>
        <div className="mt15"></div>

        <>
          <RowInput name="注意事項・トラブル内容" required>
            <TextArea
              ref={txtTroubleInformationEl}
              className={txtTroubleInformation.error ? STYLE.BORDER_RED : ""}
              value={txtTroubleInformation.value}
              onChange={(v) => {
                settxtTroubleInformation({
                  ...txtTroubleInformation,
                  value: v.target.value,
                });
              }}
              rows={4}
            />
          </RowInput>
        </>

        <RowInput name="作業報告・改修方法" required>
          <TextArea
            ref={txtRenovationMethodEl}
            className={txtRenovationMethod.error ? STYLE.BORDER_RED : ""}
            value={txtRenovationMethod.value}
            onChange={(v) => {
              settxtRenovationMethod({
                ...txtRenovationMethod,
                value: v.target.value,
              });
            }}
            rows={4}
          />
        </RowInput>

        {Number(ddlReportType.value) === 1 && (
          <RowInput name={lang.EXPORT_INVENTORY}>
            <Checkbox
              className="mt7 nonSelect"
              checked={chkAutoExport.checked}
              disabled={modeUpdate}
              onChange={(e) => {
                setChkAutoExport({
                  ...chkAutoExport,
                  checked: e.target.checked,
                });
              }}
            >
              {lang.AUTO_EXPORT_INVENTORY}
            </Checkbox>
          </RowInput>
        )}

        {/* Button footer */}
        <Row justify="end" className="mt10 mb10">
          {!isReportNewEquipment && (
            <Button
              className="buttonPC button--outline --todo-- wAuto"
              onClick={() => {
                showAttachFileLst();
              }}
            >
              <PaperClipOutlined className="orange " /> {lang.ATTACH}
            </Button>
          )}
          <Button
            className="buttonPC button--info wAuto ml15"
            onClick={() => {
              confirmSaveData();
            }}
          >
            <SaveOutlined />
            {COMMON_CONSTANT.SAVE}
          </Button>
          <Button
            className="buttonPC button--outline --todo-- wAuto ml15"
            onClick={cancelSaveData}
          >
            <CloseCircleOutlined />
            {lang.CANCEL}
          </Button>
        </Row>
      </GroupItem>
      {/* Search history check */}
      {popupHistoryCL.show && (
        <Modal
          centered
          width={1300}
          onCancel={onCloseSearchHistory}
          className="modal-msg modal-screen"
          title={<div className="center">{lang.HISTORY_CHECKLIST}</div>}
          visible={true}
          footer={[
            <Button
              disabled={!dataSelected}
              key={0}
              className="buttonPC button--info ml10"
              onClick={() => {
                sethdnChecklistID({
                  ...hdnChecklistID,
                  value: dataSelected.id,
                  message: dataSelected.checklistName,
                });
                onCloseSearchHistory();
              }}
            >
              <PlusOutlined />
              {COMMON_CONSTANT.ADD}
            </Button>,
            <Button
              key={1}
              className="buttonPC button--outline --todo-- wAuto"
              onClick={onCloseSearchHistory}
            >
              <CloseCircleOutlined />
              {lang.CLOSE}
            </Button>,
          ]}
        >
          <ListHistoryCL
            screen={false}
            setDataSelected={setDataSelected}
            idSelect={idSelect}
            setIdSelect={setIdSelect}
          />
        </Modal>
      )}
      {/* attachFileModal */}
      <Modal
        centered
        width="50%"
        bodyStyle={{ height: "400px", overflow: "auto" }}
        closeIcon={<></>}
        className="modal-msg modal-padding"
        title={<div className="center">{lang.ATTACH}</div>}
        visible={popupAttach.show}
        footer={[
          <Button
            key={1}
            className="buttonPC button--outline --todo-- wAuto"
            onClick={() => {
              setPopupAttach({ ...popupAttach, show: false });
            }}
          >
            <CloseCircleOutlined />
            {lang.CLOSE}
          </Button>,
        ]}
      >
        <div className="mb15">
          新規挿入:
          <Button
            type="link"
            onClick={() => {
              fileEl.current.click();
            }}
          >
            <PaperClipOutlined className="iconM blue" />
          </Button>
          {/* <Button type="link">
            <CameraOutlined className="iconM blue" />
          </Button> */}
        </div>
      </Modal>
    </div>
  );
}

export default EditReportNew;
